module.exports = __webpack_public_path__ + "media/images/writer/community/pc-headline-about-community-1f95106b48c0140ea90e30319683f965.png";